<template>
  <login-form class="login-form"
    redirect="/home"
    :locale-selectable="true"
    :show-logo="true"
    logo="vue-crud-lg.png"
  ></login-form>
</template>

<script>

import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify'
import LoginForm from '@/utils/auth/components/LoginForm.vue'
import {
  mapActions,
} from 'vuex'

export default {
  components: {
    LoginForm,
  },
  methods: {
    ...mapActions('auth', ['login']),
    loginAttempt () {
      this.login(this.credential).then(() => {
        this.$router.push({ path: this.redirect })
      })
    },
  },
  created () {
    // console.log("created")
    AmplifyEventBus.$on('authState', info => {
      console.log(`AUTH: event emitted by an Amplify component: ${info}`)
      if (info === 'signedIn') {
        Auth.currentSession()
          .then((data) => {
            this.login(data).then(() => {
              this.$router.push({ path: '/' }).catch(err => {})
            })
          })
          .catch((err) => console.log(err))
      }
    })

  },
  destroyed() {
    // STOP LISTENING TO EVENT
    AmplifyEventBus.$off('authState')
  }
}

</script>

<style>
  .login-form {
    text-align: center;
    padding-top: 120px;
  }
</style>
